import { useAbility } from '@cast/shared-ability-data-access';

export const useIsReliabilityMetricsAvailableInBeta = () =>
  useAbility().can('view', 'FeatureReliabilityMetricsAvailableInBeta');
